import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';
import { CardBadgeList } from './CardBadgeList';

type Props = {
  badges?: ReactNode[];
  className?: string;
  subTitle?: ReactNode;
  title?: ReactNode;
};

export const CardInformation = (props: Props) => (
  <CardWrapper className={cx('card-information', props.className)}>
    {props.title && <div className="card-information-title">{props.title}</div>}
    {props.subTitle && <div className="card-information-sub-title">{props.subTitle}</div>}
    <CardBadgeList className="card-information-badges" badges={props.badges} />
  </CardWrapper>
);

const CardWrapper = styled.div`
  padding: 5px 0;
  color: #fff;
  position: relative;
  font-size: 1rem;

  .card-information-title,
  .card-information-sub-title {
    padding: 2px 10px;
  }

  .card-information-sub-title {
    color: #888888;
  }

  .card-information-badges {
    position: absolute;
    bottom: 7px;
    right: 10px;
  }

  .card-information-sub-title,
  .card-information-badges {
    font-size: 0.85rem;
  }
`;
